import * as React from 'react';
import { withRouter } from 'react-router-dom';

import classNames from 'classnames';

import { Translate } from '@decorators';

import { getConfig, URLS } from '@base/constants';

import { Link } from '@ui';

import { IContentPanelProps } from './types';

import * as s from './ContentPanel.scss';

@Translate('components.ui.ContentPanel')
export class ContentPanelView extends React.Component<IContentPanelProps> {

	render() {
		const {
			className,
			title,
			linkUrl,
			linkText,
			children,
			titlePart,
		} = this.props;
		const catalogMainUrl = getConfig().apps.pathname || URLS.APPS;

		return (
			<div className={classNames(s.block, className)}>
				{
					(title || linkUrl) && (
						<div className={s.info}>
							<span className={s.titleWrapper}>
								{!!title && <h2 className={s.title}>{title}</h2>}
								{!!titlePart && <span className={s.titlePart}>{titlePart}</span>}
							</span>
							{linkUrl &&
								(
									<Link
										className={s.link}
										onClick={this.props.onLinkClick}
										to={`${catalogMainUrl}${linkUrl}`}
									>
										{linkText ? linkText : this.t('showMore')}
									</Link>
								)
							}
						</div>
					)
				}
				<div className={s.content}>
					{children}
				</div>
			</div>
		);
	}

}

export const ContentPanel = withRouter(ContentPanelView);
